import { storage } from '@otto-ec/global-resources/storage';
import type { GlobalStorage } from '@otto-ec/global-resources/storage';

export function getSessionStorage(): GlobalStorage {
    return storage(() => window.sessionStorage);
}
